import styled from "styled-components";
import { Button } from "@material-ui/core";
import theme from "Tools/MuiTheme";

export const STButton = styled(Button)`
  && {
    margin-top: 25px;
  }
`;

export const STMcWebhook = styled.div`
  && {
    .mc-webhook.container {
      padding-bottom: 0px;
      width: 700px;
    }

    ${theme.breakpoints.down("md")} {
      .mc-webhook.container {
        width: 100%;
      }

      form {
        display: inline-grid;
        width: 100%;

        .dropdown {
          margin-right: 0;
        }

        .dropdown select,
        input[type="text"] {
          width: 100%;
          margin-bottom: 10px;
          margin-right: 0;
        }

        input[type="text"] {
          width: calc(100% - 4px);
        }

        input[type="submit"] {
          max-width: 200px;
        }
      }
    }
  }
`;

export const STNonPrimaryMcWebhookList = styled.div`
  && {
    .mc-webhook.container {
      padding-bottom: 0px;
      width: 700px;

      .grid :nth-child(4n) {
        pointer-events: none;
        color: transparent;
      }
      
      .grid div {
        :hover {
          font-weight: normal;
        }
    }

    ${theme.breakpoints.down("md")} {
      .mc-webhook.container {
        width: 100%;
      }   
    }

    ${theme.breakpoints.only("xs")} {
      .mc-webhook.container .grid {
        grid-template-columns: none;
        border-right: none;

        span, div {
          border-right: 1px solid black;
        }
        
        div {
          margin-bottom: 15px;
        }
        
        div+span {
          border-top: 1px solid black;
        }    
      }
    }
  }
`;

export const STMcWebhookList = styled.div`
  && {
    .mc-webhook.container {
      padding-bottom: 0px;
      width: 700px;

      .grid div {
        :hover {
          font-weight: normal;
        }
    }

    ${theme.breakpoints.down("md")} {
      .mc-webhook.container {
        width: 100%;
      }   
    }

    ${theme.breakpoints.only("xs")} {
      .mc-webhook.container .grid {
        grid-template-columns: none;
        border-right: none;

        span, div {
          border-right: 1px solid black;
        }
        
        div {
          margin-bottom: 15px;
        }
        
        div+span {
          border-top: 1px solid black;
        }    
      }
    }
  }
`;
